/** Endorsement flags arrive as booleans or as 'Yes'/'True' strings depending on the endpoint. */
export function isEndorsed(value: unknown): boolean {
  if (value === true) return true;
  if (typeof value === 'string') {
    const normalizedValue = value.trim().toLowerCase();
    return normalizedValue === 'yes' || normalizedValue === 'true';
  }
  return false;
}

export function getEndorsementDisplay(value: unknown): string {
  return isEndorsed(value) ? 'Yes' : 'No';
}
